export default class SasUploadRequest {
    organizationId = null;
    fileName = null;
    contentType = null;

    constructor(organizationId, fileName, contentType){
        this.organizationId = organizationId;
        this.fileName = fileName;
        this.contentType = contentType;        
    }
}